<template>
    <div class="content">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="88px">
            <el-form-item label="机构名称:" prop="name">
                <el-input style="width:180px;"
                v-model="queryParams.name"
                placeholder="请输入机构名称"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item>
                <el-button type="cyan" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="jgList.slice((currentPage-1)*pagesize,currentPage*pagesize)">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(scope.$index+1) + ( pagesize * (currentPage-1))}}</span>
                </template>
            </el-table-column>
            <el-table-column label="检查机关" prop="jcjg"/>
            <el-table-column label="检查执行部门" prop="c_jcjg"/>
            <el-table-column label="负责人" align="center" prop="c_people" width="120" />
            <el-table-column label="电话" align="center" prop="c_phone" width="120" />
            <el-table-column label="地址" align="center" prop="c_address" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                <template slot-scope="scope">
                <el-button
                    size="small"
                    type="text"
                    @click="handleUpdate(scope.row)"
                >修改</el-button>
                <!-- <el-button
                    size="small"
                    type="text"
                    @click="handleDelete(scope.row.lsh)"
                >删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div class="page-part" style="padding:20px 20px 50px;">
            <el-pagination
                background
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page="currentPage"
                :page-sizes="[10,20,30,40]"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="this.jgList.length" style=" float:right;">
            </el-pagination>
        </div>

        <el-dialog title="监督机构信息" v-loading="loading2" :visible.sync="open" width="800px" append-to-body  :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item label="检查机关" prop="jcjg">
                        <el-input v-model="form.jcjg" clearable placeholder="请输入检查机关" ></el-input>
                    </el-form-item>
                    <el-form-item label="地区" prop="shi">
                        <el-input v-model="form.shi" clearable placeholder="请输入市" style="width:120px;" ></el-input>&nbsp;-&nbsp;<el-input v-model="form.xianqu" clearable placeholder="请输入县区" style="width:120px;" ></el-input>
                    </el-form-item>
                    <el-form-item label="检查执行部门" prop="c_jcjg">
                        <el-input v-model="form.c_jcjg" clearable placeholder="请输入检查执行部门" ></el-input>
                    </el-form-item>
                    <el-form-item label="负责人" prop="c_people">
                        <el-input v-model="form.c_people" clearable placeholder="请输入负责人姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="c_phone">
                        <el-input v-model="form.c_phone" clearable placeholder="请输入联系电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="c_address">
                        <el-input v-model="form.c_address" clearable placeholder="请输入机构地址" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" @click="onSubmit('form')">确定</el-button>
                    <el-button @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            loading2:false,
            queryParams:{
                name:'',
                alertType:'',
            },
            currentPage:1,
            pagesize:10,
            total:0,
            jgList:[],
            form:{},
            open: false,
            rules: {
                year:[
                    { required: true, message: '文号年度不能为空', trigger: 'blur' }
                ],
                bh:[
                    { required: true, message: '文号年度不能为空', trigger: 'blur' }
                ]
            },
            jcjg:'',
            token:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.jcjg = user.jcjg
        this.token = user.token
        this.baseUrl = user.baseUrl
        this.getList()
    },
    methods: {
        getList(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getOrg`,
                data:{
                    name: this.jcjg,
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                   this.jgList = res.data.data[0] || [] 
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        cancel(){
            this.form = {}
            this.reset()
            this.open = false
        },
        handleUpdate(row){
            this.open = true
            this.form = row
        },
        handleSizeChange(val){
            this.pagesize = val
        },
        handleCurrentChange(val){
            this.currentPage = val
        },
        onSubmit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        params: {
                            act: "setOrg",
                            token: `${this.token}`,
                            shi: `${this.form.shi}`,
                            xianqu: `${this.form.xianqu}`,
                            c_address: `${this.form.c_address}`,
                            c_people: `${this.form.c_people}`,
                            c_phone: `${this.form.c_phone}`,
                            jcjg: `${this.form.jcjg}`,
                            c_jcjg:`${this.form.c_jcjg}`,
                            jkdd:'',
                            fyjg1:'',
                            fyjg2:'',
                            qsjg:'',
                            c_mid: `${this.form.c_mid}`,
                        },
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.getList()
                        this.open = false
                    }).catch(res => {
                        this.$message({
                            message: '操作失败',
                            type: 'error'
                        });
                    })
                }
            })
        },
        handleQuery(){
            this.currentPage = 1;
            this.getList()
        },
        resetQuery() {
            this.reset();
        },
        reset() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                name:'',
            };
        },
    }
}
</script>


<style scoped>
</style>